<nz-form-explain
  *ngIf="(formControl?.dirty || formControl?.touched) && formControl?.errors">
  <p style="color:red"
    *ngFor="let error of validationUtilService.getUIErrorList(formControl, formName)">
    {{error.errorMessage || error }}</p>
</nz-form-explain>